// extracted by mini-css-extract-plugin
export default {"carouselSettings":"carouselSettings__carouselSettings__ROeqS","sectionName":"carouselSettings__sectionName__MbjkY","list":"carouselSettings__list__A06TM"};